// @flow

import type { State } from "@store/reducers";
import { getPagination } from "@selectors";
import type {
  DataFile,
  ExceptionsTypes,
  BaseExceptionsData,
  ExportHistoryRecord,
  TransferHistoryRecord,
  DataFileStatus,
  FilesResponse,
  DataQualityIssue,
  DataChange,
} from "@modules/data/types";
import type { PaginationExtendedType } from "@types";

export const isLoading = (state: State): boolean => {
  return state.data.requestsInProgress > 0;
};

export const isDataFileLoading = (state: State): boolean => {
  return state.data.dataFilesRequestsInProgress > 0;
};

export const getActiveDataFile = (state: State): DataFile | null => {
  return state.data.files;
};

export const isLoadDataModalOpen = (state: State): boolean => {
  return state.data.modals.loadNewData.visible;
};

export const selectFormData = (state: State): Object | null => {
  return state.data.modals.loadNewData.formData;
};

export const selectActiveHierarchyStructure = (state: State): Object | null => {
  return (state.data.activeHierarchy || {}).structure || null;
};

export const isResumeDataModalOpen = (state: State): boolean => {
  return state.data.modals.resumeData.visible;
};

export const getExceptionsTypes = (state: State): ExceptionsTypes => {
  return state.data.exceptions;
};

export const getDraftExceptions = (state: State): Array<BaseExceptionsData> => {
  return state.data.draftExceptions;
};

export const isUnsavedChangesModalOpen = (state: State): boolean => {
  return state.data.modals.unsavedChanges.visible;
};

export const getFileStatus = (state: State): DataFileStatus => {
  return state.data.dataFileStatus;
};

export const getDataMeasures = (state: State): Array<TransferHistoryRecord> | null => {
  return state.data.dataMeasures;
};
export const getDataQualityIssues = (
  state: State,
): { content: Array<DataQualityIssue>, pagination: Object, totalElements: number } => {
  return state.data.dataQualityIssues;
};

export const getExportHistory = (state: State): { content: Array<ExportHistoryRecord> } => {
  return state.data.exportHistory;
};

export const getTransferFileHistory = (state: State): FilesResponse => {
  return state.data.transferHistory;
};

export const getTransferFileHistoryFilters = (state: State) => {
  return state.form["transfer-history-grid-filter"]?.values || {};
};

export const getReviewDataChangesModalOpen = (state: State): boolean => {
  return state.data.modals.reviewChanges.visible;
};

export const getReviewChangesData = (state: State): DataChange[] => {
  return state.data.reviewChanges;
};

export const getTransferFileHistoryPagination = (state: State): PaginationExtendedType => {
  const content = state.data.transferHistory;
  return getPagination(content);
};
